"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blockfrost = void 0;
var util_1 = require("../../common/util");
var REQUEST_LIMIT = 100;
var TIMEOUT_LIMIT = 30;
var BLOCKFROST_ERROR = function () { return new Error("Blockfrost error"); };
var Blockfrost = /** @class */ (function () {
    function Blockfrost(blockfrostApiKey) {
        this.blockfrostApiKey = blockfrostApiKey;
    }
    Blockfrost.prototype.request = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var networkEndpoint, blockfrostApiKey, error_1;
            var _c = _b.body, body = _c === void 0 ? null : _c, _d = _b.endpoint, endpoint = _d === void 0 ? "" : _d, _e = _b.networkId, networkId = _e === void 0 ? 0 : _e, _f = _b.headers, headers = _f === void 0 ? {} : _f, _g = _b.method, method = _g === void 0 ? "GET" : _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        networkEndpoint = networkId == 0 ?
                            'https://cardano-preprod.blockfrost.io/api/v0' :
                            'https://cardano-mainnet.blockfrost.io/api/v0';
                        blockfrostApiKey = this.blockfrostApiKey[networkId];
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(networkEndpoint).concat(endpoint), {
                                headers: __assign({ project_id: blockfrostApiKey }, headers),
                                method: method,
                                body: body
                            })];
                    case 2: return [4 /*yield*/, (_h.sent()).json()];
                    case 3: return [2 /*return*/, _h.sent()];
                    case 4:
                        error_1 = _h.sent();
                        // if (error?.status_code != 404) {
                        // console.error(error);
                        // }
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Blockfrost.prototype.getTxBlockHash = function (txHash_1) {
        return __awaiter(this, arguments, void 0, function (txHash, networkId) {
            var txInfo, i;
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            endpoint: "/txs/".concat(txHash),
                            networkId: networkId,
                            method: "GET"
                        })];
                    case 1:
                        txInfo = _a.sent();
                        // console.log(0, txInfo);
                        if (txInfo === null || txInfo === void 0 ? void 0 : txInfo.block) {
                            return [2 /*return*/, txInfo.block];
                        }
                        i = 1;
                        _a.label = 2;
                    case 2:
                        if (!(i < REQUEST_LIMIT)) return [3 /*break*/, 6];
                        return [4 /*yield*/, (0, util_1.awaitTimeout)(TIMEOUT_LIMIT * 1000)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.request({
                                endpoint: "/txs/".concat(txHash),
                                networkId: networkId,
                                method: "GET"
                            })];
                    case 4:
                        txInfo = _a.sent();
                        // console.log(i, txInfo);
                        if (txInfo === null || txInfo === void 0 ? void 0 : txInfo.block) {
                            return [2 /*return*/, txInfo.block];
                        }
                        _a.label = 5;
                    case 5:
                        ++i;
                        return [3 /*break*/, 2];
                    case 6: throw BLOCKFROST_ERROR();
                }
            });
        });
    };
    Blockfrost.prototype.getBlockConfirmations = function (blockHash_1) {
        return __awaiter(this, arguments, void 0, function (blockHash, networkId) {
            var blockInfo;
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            endpoint: "/blocks/".concat(blockHash),
                            networkId: networkId,
                            method: "GET"
                        })];
                    case 1:
                        blockInfo = _a.sent();
                        if (!blockInfo)
                            throw BLOCKFROST_ERROR();
                        return [2 /*return*/, blockInfo.confirmations];
                }
            });
        });
    };
    Blockfrost.prototype.getLatestBlock = function () {
        return __awaiter(this, arguments, void 0, function (networkId) {
            var latestBlock;
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            endpoint: "/blocks/latest",
                            networkId: networkId,
                            method: "GET"
                        })];
                    case 1:
                        latestBlock = _a.sent();
                        if (!latestBlock)
                            throw BLOCKFROST_ERROR();
                        return [2 /*return*/, latestBlock];
                }
            });
        });
    };
    Blockfrost.prototype.getProtocolParameters = function () {
        return __awaiter(this, arguments, void 0, function (networkId) {
            var latestBlock, epoch, protocolParameters;
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLatestBlock(networkId)];
                    case 1:
                        latestBlock = _a.sent();
                        if (!latestBlock)
                            throw BLOCKFROST_ERROR();
                        epoch = latestBlock.epoch;
                        return [4 /*yield*/, this.request({
                                endpoint: "/epochs/".concat(epoch, "/parameters"),
                                networkId: networkId,
                                method: "GET"
                            })];
                    case 2:
                        protocolParameters = _a.sent();
                        if (!protocolParameters)
                            throw BLOCKFROST_ERROR();
                        return [2 /*return*/, protocolParameters];
                }
            });
        });
    };
    Blockfrost.prototype.getAddressUtxos = function (address_1) {
        return __awaiter(this, arguments, void 0, function (address, networkId) {
            var utxos;
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            endpoint: "/addresses/".concat(address, "/utxos"),
                            networkId: networkId,
                            method: "GET"
                        })];
                    case 1:
                        utxos = _a.sent();
                        if (!utxos)
                            throw BLOCKFROST_ERROR();
                        return [2 /*return*/, utxos];
                }
            });
        });
    };
    return Blockfrost;
}());
exports.Blockfrost = Blockfrost;
